import _ from "lodash";

const INIT_EMPTY_FORM_STATE = "INIT_EMPTY_FORM_STATE";
const SET_DEFAULT_VALUES = "SET_DEFAULT_VALUES";
const SET_FORM_VALUE = "SET_FORM_VALUE";
const SET_ERRORS_ON_FORM = "SET_ERRORS_ON_FORM";
const CLEAR_ERRORS_ON_FORM = "CLEAR_ERRORS_ON_FORM";
const RESET_FORM_STATUS = "RESET_FORM_STATUS";

const initialState = {
  validations: {
    isEmail: { msg: "errorMsg.notValid.emailAddress" }
  },

  updateAliasDestinations: { fields: {}, errors: [] },
  resetPassword: { fields: {}, errors: [] },
  addDomain: {
    fields: {
      max_email_accounts_25gb: { value: -1 },
      max_email_accounts_archive: { value: -1 },
      max_email_accounts: { value: -1 },
      max_email_quota: { value: "26843545600" },
      catch_all_enabled: { value: false },
      allow_nets: { value: "" },
      imap_disabled: { value: true },
      pop_disabled: { value: true },
      smtp_disabled: { value: true },
      webmail_disabled: { value: true }
    },
    errors: []
  },

  updateDomainServices: {
    fields: {
      imap_disabled: { value: true },
      pop_disabled: { value: true },
      smtp_disabled: { value: true },
      webmail_disabled: { value: true }
    },
    errors: []
  },

  updateDomainSecurity: {
    fields: {
      allow_nets: { value: "" }
    },
    errors: []
  },

  updateDomainLimits: {
    fields: {
      max_email_accounts_25gb: { value: -1 },
      max_email_accounts_archive: { value: -1 },
      max_email_accounts: { value: -1 },
      max_email_quota: { value: "26843545600" }
    },
    errors: []
  },

  updateDomainAdvanced: {
    fields: {
      catch_all_enabled: { value: false },
      catch_all_destination: { value: undefined },
      antispam_level: { value: 2 }
    },
    errors: []
  },

  updateEmailAccountPassword: {
    fields: {
      password: { value: undefined },
      password_confirmation: { value: undefined }
    },
    errors: []
  },

  updateEmailAccountLimits: {
    fields: {
      max_email_quota: { value: "26843545600" },
      imap_disabled: { value: true },
      pop_disabled: { value: true },
      smtp_disabled: { value: true },
      webmail_disabled: { value: true }
    },
    errors: []
  },

  updateEmailAccountAutoresponder: {
    fields: {
      autoresponder_enabled: { value: false },
      autoresponder_body: { value: "" },
      autoresponder_subject: { value: "" },
      start_date: { value: undefined },
      end_date: { value: undefined }
    },
    errors: []
  },

  updateEmailAccountAdvanced: {
    fields: {
      forwards: { value: "" },
      bounce_mail: { value: false },
      keep_copy: { value: false }
    },
    errors: []
  },

  addEmailAccount: {
    fields: {
      max_email_quota: { value: "26843545600" },
      forwards: { value: "" }
    },
    errors: [],
    isPristine: true
  },

  addAliasDomain: {
    fields: {
      name: { value: "" }
    },
    errors: [],
    isPristine: true
  },

  addAliasEmailAccount: {
    fields: {
      destinations: { value: "" }
    },
    errors: [],
    isPristine: true
  },

  addOrder: {
    fields: {
      max_emails_no_8gb: { value: 3 },
      max_emails_no_25gb: { value: 0 },
      max_emails_no_archive: { value: 0 },
      geo_area: { value: "it" },
      promocode: { value: "" },
      is_company: { value: true },
      billing_cycle: { value: "annually" },
      companyname: { value: "" }
    },
    errors: [],
    isPristine: true
  },

  addImport: {
    fields: {
      type: { value: "domains" },
      expert_mode: { value: false }
    },
    errors: [],
    isPristine: true
  },

  ownershipCheckEmailVerification: {
    fields: {
      verification_email_address: { value: 1 }
    },
    errors: {}
  },

  ownershipCheckCodeVerification: {
    fields: {
      possession_a_record: { value: undefined }
    },
    errors: {}
  },

  addManager: {
    fields: {
      max_domains: { value: -1 },
      max_email_accounts: { value: -1 },
      max_email_accounts_25gb: { value: -1 },
      max_email_accounts_archive: { value: -1 }
    },
    errors: [],
    isPristine: true
  },

  updateManagerPassword: {
    fields: {},
    errors: []
  },

  updateManager: {
    fields: {
      max_domains: { value: -1 },
      max_email_accounts: { value: -1 },
      max_email_accounts_25gb: { value: -1 },
      max_email_accounts_archive: { value: -1 }
    },
    errors: [],
    isPristine: true
  },

  addMigration: {
    fields: {
      has_masteruser: { value: false },
      first_execution_date: { value: undefined }
    },
    errors: [],
    isPristine: true
  },

  addCustomization: {
    fields: {},
    errors: [],
    isPristine: true
  },

  addMainCustomization: {
    fields: {},
    errors: [],
    isPristine: true
  },

  filterAudits: {
    fields: {},
    errors: [],
    isPristine: true
  },

  verifyOTP: {
    fields: {},
    errors: [],
    isPristine: true
  },

  updateAccount: {
    fields: {},
    errors: [],
    isPristine: true
  },

  updateAccountPanelSettings: {
    fields: {},
    errors: [],
    isPristine: true
  },

  updateCustomization: {
    fields: {},
    errors: [],
    isPristine: true
  },

  resetPassword: {
    fields: {},
    errors: [],
    isPristine: true
  },

  signUp: {
    fields: {
      language: { value: "it" }
    },
    errors: [],
    isPristine: true
  }
};

// TODO: find a better place for this, in this way the state
// is not updated in a "pure" way. This modification should be triggered
// in the <Form> component
function checkFormValidationStatus(state) {
  const invalids = [];

  for (const field in state) {
    if (state[field].isValid === false) {
      invalids.push(field);
    }
  }

  if (invalids.length > 0) {
    return false;
  }
  return true;
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case INIT_EMPTY_FORM_STATE:
      if (!state[action.formName]) {
        return {
          ...state,
          [action.formName]: {
            fields: {},
            errors: [],
            isPristine: true
          }
        };
      }

    case SET_FORM_VALUE:
      const updatedState = {
        ...state,
        [action.formName]: {
          ...state[action.formName],
          fields: {
            ...state[action.formName].fields,
            [action.field]: {
              value: action.value,
              isValid: action.isValid,
              errorMessage: action.errorMessage
            }
          }
        }
      };

      const isFormValid = checkFormValidationStatus(updatedState[action.formName].fields);

      return {
        ...updatedState,
        [action.formName]: {
          ...updatedState[action.formName],
          isFormValid
        }
      };

    case SET_ERRORS_ON_FORM:
      return {
        ...state,
        [action.formName]: {
          ...state[action.formName],
          errors: action.errors
        }
      };

    case CLEAR_ERRORS_ON_FORM:
      return {
        ...state,
        [action.formName]: {
          ...state[action.formName],
          errors: [],
          message: undefined
        }
      };

    case RESET_FORM_STATUS:
      return {
        ...state,
        [action.formName]: {
          ...initialState[action.formName]
        }
      };

    case SET_DEFAULT_VALUES:
      let defaultFields = {};
      // compose the {nameOfTheField: { value: valueOfTheField}}
      // structure
      _.each(action.defaultValues, (v, k) => {
        defaultFields[k] = { value: v };
      });

      return {
        ...state,
        [action.formName]: {
          ...initialState[action.formName],
          isPristine: false,
          fields: {
            ...state[action.formName].fields,
            ...defaultFields
          }
        }
      };

    default:
      return state;
  }
}

export function initEmptyFormState(formName) {
  return {
    type: INIT_EMPTY_FORM_STATE,
    formName
  };
}

export function setFormValues(formName, field, value, isValid, errorMessage) {
  return {
    type: SET_FORM_VALUE,
    formName,
    field,
    value,
    isValid,
    errorMessage
  };
}

export function setErrorsOnForm(formName, errors) {
  return {
    type: SET_ERRORS_ON_FORM,
    formName,
    errors
  };
}

export function clearErrorsOnForm(formName) {
  return {
    type: CLEAR_ERRORS_ON_FORM,
    formName
  };
}

export function resetFormStatus(formName) {
  return {
    type: RESET_FORM_STATUS,
    formName
  };
}

export function setDefaultValuesOn(formName, defaultValues) {
  return {
    type: SET_DEFAULT_VALUES,
    formName,
    defaultValues
  };
}
